import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getCompaniesBankAccounts = (): Promise<ISelectModel<string>[]> =>
  API.get('api/accommodation/companies/bank-accounts').then(response => response?.data);
